import service from "@/api/request";
export const getPaperList = (params) => service.getByParams('/courseAdmin/paper/page', params);
export const fetchPaperDetail = (id) => service.getByParams('/courseAdmin/paper/get', { id });
export const changePaperStatus = (idList, status) => service.postByJson('/courseAdmin/paper/changeStatus', {
    idList,
    status,
});
export const copyPaper = (idList, categoryId) => service.postByJson('/courseAdmin/paper/copy', {
    idList,
    categoryId,
});
export const transferPaper = (idList, categoryId) => service.postByJson('/courseAdmin/paper/move', {
    idList,
    categoryId,
});
export const saveTestPaper = (data) => service.postByJson('/courseAdmin/paper/saveOrUpdate', data);
export const getPaperCategoryList = (keyword) => service.getByParams('/courseAdmin/paper/category/list', { name: keyword });
export const addPaperCategory = (data) => service.postByQs('/courseAdmin/paper/category/add', data);
export const updatePaperCategory = (data) => service.postByJson('/courseAdmin/paper/category/update', data);
export const deletePaperCategory = (data) => service.postByQs('/courseAdmin/paper/category/delete', data);
export const getPaperListForExam = (params) => service.getByParams('/courseAdmin/paper/validPage', params);
